// Overlay.
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const HIDE_OVERLAY = 'HIDE_OVERLAY';
export const UPDATE_OVERLAY = 'UPDATE_OVERLAY';
